module.exports = __webpack_public_path__ + "img/resized-APP-0009-2.b8332ca0.png";